import { create } from 'zustand';
import { User } from '../types';

interface AuthState {
  user: User | null;
  access_token: string | null;
  refresh_token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, access_token: string, refresh_token: string) => void;
  clearAuth: () => void;
}

const ANGULAR_APP_URL = 'http://localhost:4200';

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  access_token: localStorage.getItem('access_token'),
  refresh_token: localStorage.getItem('refresh_token'),
  isAuthenticated: !!localStorage.getItem('access_token'),

  setAuth: (user, access_token, refresh_token) => {
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, access_token, refresh_token, isAuthenticated: true });

    // Redirect to Angular app after login
    window.location.href = `${ANGULAR_APP_URL}/dashboard?token=${access_token}&refresh=${refresh_token}`;
  },

  clearAuth: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    set({ user: null, access_token: null, refresh_token: null, isAuthenticated: false });
  },
}));